import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity TimberClasses


export interface TimberClass {
    id: ID;

    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    scopeGroupId: ID;

    }




export interface CreateTimberClass {
    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    }


export interface UpdateTimberClass {
    
    name: string;

    
    description?: string;

    
    reportNameShort?: string;

    
    reportNameLong?: string;

    
    }

export interface PresentationTimberClassRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryTimberClass {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: TimberClass): PrimaryTimberClass | undefined {
        return entity ? new PrimaryTimberClass(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryTimberClass {
        return new PrimaryTimberClass(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryTimberClass {
        let vals = path?.split('/');
        return new PrimaryTimberClass(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryTimberClass[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: TimberClass): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityTimberClass {
    id: PrimaryTimberClass;
    data: UpdateTimberClass;


    constructor(id: PrimaryTimberClass, data: UpdateTimberClass) {
        this.id = id;
        this.data = data;
    }
}
